import clients from 'redux/clients'
import actionsFactory from './actions'
export { default as Cellphonerecharge } from './CellphonerechargeContainer'
export { default as reducer } from './reducer'
export { default as ModalTerms } from './ModalTerms'
const {
  cloudloyalty: { client }
} = clients
export const actions = actionsFactory(client)

export {
  default as CellphonerechargePlaceholder
} from './CellphonerechargePlaceholder'



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/index.js